import React from 'react';

export const RocketIcon = ({ className = '' }) => (
  <i className={`bi bi-rocket-takeoff-fill text-blue-500 ${className}`}></i>
);

export const TargetIcon = ({ className = '' }) => (
  <i className={`bi bi-bullseye text-emerald-500 ${className}`}></i>
);

export const TrophyIcon = ({ className = '' }) => (
  <i className={`bi bi-trophy-fill text-amber-500 ${className}`}></i>
);

export const ChartIcon = ({ className = '' }) => (
  <i className={`bi bi-bar-chart-line-fill text-blue-500 ${className}`}></i>
);

export const PeopleIcon = ({ className = '' }) => (
  <i className={`bi bi-people-fill text-indigo-500 ${className}`}></i>
);

export const LightbulbIcon = ({ className = '' }) => (
  <i className={`bi bi-lightbulb-fill text-amber-500 ${className}`}></i>
);

export const GlobeIcon = ({ className = '' }) => (
  <i className={`bi bi-globe-americas text-emerald-500 ${className}`}></i>
);

export const CheckCircleIcon = ({ className = '' }) => (
  <i className={`bi bi-check-circle-fill text-emerald-500 ${className}`}></i>
);

export const StarIcon = ({ className = '' }) => (
  <i className={`bi bi-star-fill text-amber-500 ${className}`}></i>
);

export const HeartIcon = ({ className = '' }) => (
  <i className={`bi bi-heart-fill text-red-500 ${className}`}></i>
);